export interface GeoCaptura {
  lat: number;
  lon: number;
  /** metros — quanto maior, mais grosseira a posição */
  precisao?: number;
}

/**
 * Geolocalização do navegador para a trilha de aceite.
 *
 * Regras que valem aqui:
 *
 * 1. **Nunca bloqueia o aceite.** Se o usuário negar, o navegador não suportar ou o GPS
 *    demorar, a função devolve `null` e o aceite segue. Impedir alguém de aceitar um termo
 *    por causa de permissão de localização criaria bloqueio de portal por um dado acessório.
 *
 * 2. **Pedida quando o termo abre, não no clique.** Assim o prompt do navegador aparece
 *    enquanto a pessoa lê, e a resposta já está pronta na hora de decidir.
 *
 * 3. `enableHighAccuracy: false` de propósito: para prova de aceite, bairro/cidade basta, e
 *    ligar o GPS fino gasta bateria e demora — o que aumenta a chance de vir vazio.
 *
 * Só funciona em HTTPS (ou localhost) — em HTTP o navegador nem pergunta.
 */
export function obterGeolocalizacao(timeoutMs = 8000): Promise<GeoCaptura | null> {
  return new Promise((resolve) => {
    if (!("geolocation" in navigator)) {
      resolve(null);
      return;
    }

    let respondido = false;

    const encerrar = (valor: GeoCaptura | null) => {
      if (respondido) return;
      respondido = true;
      resolve(valor);
    };

    // rede de segurança: alguns navegadores ignoram o timeout das opções
    const relogio = setTimeout(() => encerrar(null), timeoutMs + 500);

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        clearTimeout(relogio);
        encerrar({
          lat: pos.coords.latitude,
          lon: pos.coords.longitude,
          precisao: pos.coords.accuracy,
        });
      },
      () => {
        clearTimeout(relogio);
        encerrar(null);
      },
      { enableHighAccuracy: false, timeout: timeoutMs, maximumAge: 300000 }
    );
  });
}
